import { syncTypes } from '~/sqlite/syncDataTypes';

import { syncQueue } from './SyncQueue';

export type QueuedIssue = {
    id?: string | number | null
    guid?: string | null
    machineId?: string | number
    pendingSync?: boolean
};

export const issueQueueIdKey = (id: string | number) => `id:${id}`;
export const issueQueueGuidKey = (guid: string) => `guid:${guid}`;

export async function listQueuedIssues(userId: number): Promise<QueuedIssue[]> {
    const rows = await syncQueue.listByUserId(userId);
    const queued: QueuedIssue[] = [];
    for (const row of rows) {
        if (row.typeOfData !== syncTypes.ADD_ISSUE) {
            continue;
        }
        try {
            queued.push(JSON.parse(row.data) as QueuedIssue);
        } catch {
            // Malformed rows are dropped by SyncManager; ignore them here.
        }
    }
    return queued;
}

export function pendingIssueKeyMap(rows: QueuedIssue[]): Record<string, true> {
    const pending: Record<string, true> = {};
    rows.forEach(row => {
        if (row.id !== undefined && row.id !== null && String(row.id) !== '') {
            pending[issueQueueIdKey(row.id)] = true;
        }
        if (row.guid) {
            pending[issueQueueGuidKey(String(row.guid))] = true;
        }
    });
    return pending;
}

/** Same identity rules as offline issue enqueueReplace: server/sqlite id, otherwise guid. */
export function isIssueAwaitingSync(
    pending: Record<string, true>,
    loaded: boolean,
    issueId?: string | number | null,
    guid?: string | null,
    pendingSync?: boolean,
): boolean {
    const queued = !!(
        (issueId !== undefined && issueId !== null && issueId !== '' && pending[issueQueueIdKey(issueId)])
        || (guid && pending[issueQueueGuidKey(String(guid))])
    );
    if (loaded) {
        return queued;
    }
    return queued || !!pendingSync;
}
